import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

import { useAuth } from '@/features/auth/hooks/useAuth';
import { ROTAS } from '@/shared/lib/rotas';
import { Button } from '@/shared/ui/button';

/** Último empurrão da página. Mesmo destino do CTA do topo, para quem rolou tudo. */
export function SecaoCta() {
  const { autenticado, carregando } = useAuth();
  const logado = autenticado && !carregando;

  return (
    <section className="relative overflow-hidden border-b border-border bg-gradient-nohra-dark py-20">
      <div className="absolute left-1/2 top-1/2 h-[480px] w-[480px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-white/10 blur-3xl" />

      <div className="relative mx-auto max-w-3xl px-4 text-center sm:px-6">
        <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">
          Comece pelo próximo paciente
        </h2>
        <p className="mt-4 text-lg text-white/85">
          Crie a conta com o seu CRMV e traga o primeiro caso. O resto da rotina vem junto.
        </p>

        <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
          {logado ? (
            <Button asChild size="lg" className="bg-white text-[#691241] shadow-lg hover:bg-white/90">
              <Link to={ROTAS.dashboard}>
                Abrir plataforma
                <ArrowRight className="ml-1" />
              </Link>
            </Button>
          ) : (
            <>
              <Button
                asChild
                size="lg"
                className="bg-white text-[#691241] shadow-lg hover:bg-white/90"
              >
                <Link to={ROTAS.registro}>
                  Criar conta
                  <ArrowRight className="ml-1" />
                </Link>
              </Button>
              <Button
                asChild
                size="lg"
                variant="outline"
                className="border-white/40 bg-transparent text-white hover:bg-white/10 hover:text-white"
              >
                <Link to={ROTAS.login}>Entrar</Link>
              </Button>
            </>
          )}
        </div>
      </div>
    </section>
  );
}
